import React from 'react'

const ContactStrip = () => {
  return (
    <>
        <div className='contact-strip'>
            <h1>Contact us: <span>contact@zeeepy.com</span></h1>
        </div>
    </>
  )
}

export default ContactStrip